import type { IAnalyticsRepository } from '@src/domain/analytics/repository/analytics_repository';
import { UserProperties } from '@src/domain/analytics/value_objects/user_properties';

/**
 * Set User Properties Use Case
 * Handles setting user properties for analytics tracking
 */
export class SetUserPropertiesUseCase {
    constructor(private readonly analyticsRepository: IAnalyticsRepository) { }

    async execute(params: {
        userId?: string;
        userRole?: string;
        universityId?: string;
        universityName?: string;
        properties?: Record<string, any>;
    }): Promise<void> {
        const userProperties = UserProperties.create({
            userId: params.userId,
            userRole: params.userRole,
            universityId: params.universityId,
            universityName: params.universityName,
            properties: params.properties,
        });

        await this.analyticsRepository.setUserProperties(userProperties);

        // Also set the user ID separately for GA4
        if (params.userId) {
            await this.analyticsRepository.setUserId(params.userId);
        }
    }
}
